/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Form_Mfg_DateInputs */

const vi_aml_form_mfg_date = /** @type {(inputs: Aml_Form_Mfg_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NSX`)
};

/**

* @param {Aml_Form_Mfg_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_form_mfg_date = /** @type {((inputs?: Aml_Form_Mfg_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Form_Mfg_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_form_mfg_date(inputs)
});